import React from 'react';
import Page from '..';
import PageTicketOfflinePrices from './OfflinePrices';
import DualListBox from '../../DualListBox';
import Tabs from '../../Tabs';
import BatchTab from './Tabs/BatchTab';
import Tag from '../../Tag';
import useStore from '../../Hooks/useStore';
import ProductTab from './Tabs/ProductTab';
import ModelTab from './Tabs/ModelTab';
import Form from '../../Form';

function PageTicket() {
  const [getters, setters] = useStore();
  const {
    ticket: { getTicket },
    form: { getTransformations, getBannerConfigurations: getConfig, getForm },
    banner: { getBackgroundImage },
  } = getters;
  const {
    ticket: { setTicket },
  } = setters;
  const form = getForm('banner');

  const ref = React.createRef<HTMLDivElement>();
  const [screenHeight, setScreenHeight] = React.useState(window.innerHeight);
  const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);

  const aspect = 0.7;
  const margin = 0.02 * screenHeight;
  const previewHeaderHeight = 0.06 * screenHeight;
  const previewWidth = ((0.88 - 0.06) * screenHeight - 15) * aspect;
  const previewHeight = 0.88 * screenHeight;
  const elements = getTransformations(previewWidth, form);
  const { height } = getConfig(previewWidth, form);
  const backGroundImageUrl = getBackgroundImage(form);

  const { pinnedProducts, selectedProducts } = getTicket('form.batch');

  const hasPinnedProducts = pinnedProducts.length > 0;
  const hasSelectedProducts = selectedProducts.length > 0;

  const selectedProductsTagLabel = hasSelectedProducts
    ? `${selectedProducts.length} ${
        selectedProducts.length > 1
          ? 'produtos selecionados'
          : 'produto selecionado'
      }`
    : 'Sem produtos selecionados';
  const pinnedProductsTagLabel = `${pinnedProducts.length} ${
    pinnedProducts.length > 1 ? 'produtos fixados' : 'produto fixado'
  }
  `;
  const tagLabel = hasPinnedProducts
    ? pinnedProductsTagLabel
    : selectedProductsTagLabel;

  const singleProduct =
    selectedProducts.length <= 1 || pinnedProducts.length === 1;

  const updateScreen = () => {
    setScreenHeight(window.innerHeight);
    setScreenWidth(window.innerWidth);
  };

  React.useEffect(() => {
    window.addEventListener('resize', updateScreen);
    return () => {
      window.removeEventListener('resize', updateScreen);
    };
  }, []);

  return (
    <Page className="page-banner">
      <div
        ref={ref}
        style={{
          position: 'relative',
          transition: 'min-width 500ms, max-width 500ms',
          minWidth: `${screenWidth - previewWidth - 5 * margin}px`,
          minHeight: `${previewHeight - 2 * margin - 15}px`,
          maxHeight: `${previewHeight - 2 * margin - 15}px`,
          margin: `0 ${margin}px`,
          padding: `${2 * margin}px ${margin}px ${0}px ${margin}px`,
        }}
        className="form-container"
      >
        <Tabs
          tab={getTicket('activeTab')}
          setTab={(value: number) => setTicket('activeTab', value)}
          tags={[<Tag>{tagLabel}</Tag>]}
          items={[
            {
              label: 'MODELO',
              children: <ModelTab />,
            },
            {
              label: singleProduct ? 'PRODUTO' : 'PRODUTOS',
              children: <ProductTab />,
            },
            {
              label: 'LOTE',
              children: <BatchTab />,
            },
          ]}
        />
      </div>
      <Form.Banner.Preview
        elements={elements}
        width={previewWidth}
        height={height}
        headerHeight={previewHeaderHeight}
        margin={margin}
        backGroundImageUrl={backGroundImageUrl}
      />
    </Page>
  );
}

export default Object.assign(PageTicket, {
  OffilineProducts: PageTicketOfflinePrices,
});
